// extracted by mini-css-extract-plugin
export default {"container":"OurPartners_container__DFfNQ","heading":"OurPartners_heading__LNDAC","partnerList":"OurPartners_partnerList__Ip60W","card":"OurPartners_card__KQMCe"};